import React, { useEffect, useState } from "react";
import { useResizeDetector } from "react-resize-detector";
import styled from "styled-components";

interface StickyColumnProps extends React.HTMLAttributes<HTMLDivElement> {
	topOffset?: number;
	bottomOffset?: number;
}

export const StickyColumn: React.FC<StickyColumnProps> = ({ topOffset, bottomOffset, children, ...htmlProps }) => {
	const [windowHeight, setWindowHeight] = useState(0);

	useEffect(() => {
		const listener = (): void => {
			setWindowHeight(window.innerHeight);
		};
		listener();
		document.addEventListener("resize", listener);
		return () => document.removeEventListener("resize", listener);
	}, []);

	const { ref, height } = useResizeDetector({
		handleWidth: false,
	});

	return (
		<Container
			ref={ref}
			{...htmlProps}
			height={height ?? 0}
			fit={(height ?? 0) < windowHeight - (topOffset ?? 0)}
			topOffset={topOffset}
			bottomOffset={bottomOffset}
		>
			{children}
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => !["height", "topOffset", "bottomOffset", "fit"].includes(prop),
})<{
	height: number;
	topOffset?: number;
	bottomOffset?: number;
	fit?: boolean;
}>`
	transition: top ease-in-out 0.2s;
	position: sticky;
	top: ${({ height, topOffset = 0, bottomOffset = 0, fit }) =>
		fit ? `${topOffset}px` : `min(${topOffset}px, calc(100vh - ${height}px - ${bottomOffset}px))`};
`;
